import type { DialogConfig } from "../types"

export const defaultDialogConfig: DialogConfig = {
    typewriterSpeed: 50,
    theme: "default",
    effectRepeats: {
        shake: 3,
        surprise: 2,
        bounce: 4,
        heartbeat: 3,
        glow: 2,
        rainbow: 3,
    },
}

export * from "./resources"
